const DEFAULT_API_SCOPE =
    '18c22d22-3c6e-4790-a6bc-a428631f78ea/ai.invoke'

export const entraApiScope =
    DEFAULT_API_SCOPE
